import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { PricingImportRequest } from '@/api/endpoints/pricing'
import { pricingApi } from '@/api/endpoints/pricing'

export function usePricingImport() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: PricingImportRequest) => pricingApi.import(data),
    onSuccess: () => {
      // Invalidate prices queries to refresh
      queryClient.invalidateQueries({ queryKey: ['prices'] })
      queryClient.invalidateQueries({ queryKey: ['products'] })
    },
  })
}
